import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "switch", "label"]

  toggle(event) {
    // Show loading state
    const checkbox = event.target
    const switchDiv = this.switchTarget
    const label = this.labelTarget

    // Disable interactions
    checkbox.disabled = true
    switchDiv.style.opacity = "0.6"
    switchDiv.style.cursor = "wait"

    // Add loading indicator to label
    const originalText = label.innerHTML
    label.innerHTML = `<span class="text-blue-600 font-medium">Updating...</span>`

    // Submit the form
    this.formTarget.requestSubmit()

    // Fallback timeout to restore state if something goes wrong
    setTimeout(() => {
      checkbox.disabled = false
      switchDiv.style.opacity = "1"
      switchDiv.style.cursor = "pointer"
      label.innerHTML = originalText
    }, 5000)
  }

  connect() {
    // Ensure all toggle switches have smooth transitions
    const toggles = this.element.querySelectorAll('.toggle-switch')
    toggles.forEach(toggle => {
      toggle.classList.add('transition-all', 'duration-200', 'ease-in-out')
    })
  }
}